import { publicApi } from "@/lib/axios/instances";
import { City } from "@/types/city";

export const fetchCities = async (
  config: Parameters<typeof publicApi.get>[1] = {}
): Promise<City[]> => {
  const { data } = await publicApi.get<City[]>('/cities', { ...config });
  return data;
};

export const fetchCitiesFromVK = async (q: string): Promise<{ name: string }[]> => {
  const { data } = await publicApi.get<{ name: string }[]>('/cities/vk', {
    params: { q }
  });
  return data;
};
